import $ from 'jquery';

import 'jquery.ui.widget';
import 'selectboxit';

export default class Select {

	constructor() {

		$( '.contact-wrapper select' )

			.selectBoxIt({

				autoWidth: false

			})

		;

	}

}


// WEBPACK FOOTER //
// src/js/app/splash-page/modules/select.js